import { PstResultVO } from '@domain/vo/phs/pst/result/PstResultVO';
import { programLanguageTypeTextMap } from '@domain/constant/programLanguageType';
import classnames from 'classnames/bind';
import styles from './resultTable.module.scss';

const cx = classnames.bind(styles);

const EmptyResultTable = () => {
  return (
    <table className={cx('resultTable')}>
      <thead>
        <tr>
          <th className={cx('th', 'score')}>점수</th>
          <th className={cx('th', 'time')}>소요 시간</th>
          <th className={cx('th', 'language')}>제출 언어</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className={cx('td', 'score')}>-</td>
          <td className={cx('td', 'time')}>-</td>
          <td className={cx('td', 'language')}>-</td>
        </tr>
      </tbody>
    </table>
  );
};

interface ResultTableProps {
  pstResult: PstResultVO;
}

const ResultTable = ({ pstResult }: ResultTableProps) => {
  if (!pstResult || !pstResult.lastSubmitResult) return <EmptyResultTable />;

  const { score, language, elapsedTime, version, finalPassedStepText } = pstResult.lastSubmitResult;

  const languageText = programLanguageTypeTextMap[language];
  const scoreText = score !== undefined ? `${score}점/100점` : '-';
  const timeText = elapsedTime !== undefined ? `${elapsedTime}분` : '-';

  const getContents = () => {
    switch (version) {
      case 'V1':
        return (
          <>
            <thead>
              <tr>
                <th className={cx('th', 'score')}>점수</th>
                <th className={cx('th', 'time')}>소요 시간</th>
                <th className={cx('th')}>제출 언어</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={cx('td', 'score')}>{scoreText}</td>
                <td className={cx('td', 'time')}>{timeText}</td>
                <td className={cx('td', 'language', { icon: !!languageText }, languageText)}>{!languageText && '-'}</td>
              </tr>
            </tbody>
          </>
        );
      case 'V2':
        return (
          <>
            <thead>
              <tr>
                <th className={cx('th', 'passStep')}>통과단계</th>
                <th className={cx('th', 'score')}>점수</th>
                <th className={cx('th', 'time')}>소요 시간</th>
                <th className={cx('th')}>제출 언어</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={cx('td', 'passStep')}>{finalPassedStepText}</td>
                <td className={cx('td', 'score')}>{scoreText}</td>
                <td className={cx('td', 'time')}>{timeText}</td>
                <td className={cx('td', 'language', { icon: !!languageText }, languageText)}>{!languageText && '-'}</td>
              </tr>
            </tbody>
          </>
        );
    }
  };

  return <table className={cx('resultTable')}>{getContents()}</table>;
};

export default ResultTable;
